export type Language = 'it' | 'en'

export const translations = {
  it: {
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      treasury: 'Tesoreria',
      treasuryDesc: 'Gestione tesoreria, previsioni, debiti, investimenti',
      assistant: 'Assistente AI',
      aiGovernance: 'Governance AI',
      transactions: 'Transazioni',
      transactionsDesc: 'Movimenti bancari e situazione di cassa',
      invoices: 'Fatture',
      invoicesDesc: 'Gestisci fatture attive e passive',
      reconciliation: 'Riconciliazione',
      reconciliationDesc: 'Riconcilia transazioni con fatture',
      categorize: 'Categorizza',
      categorizeDesc: 'Classifica automaticamente le transazioni',
      reports: 'Report',
      reportsDesc: 'Analisi finanziarie e report dettagliati',
      forecasts: 'Previsioni',
      forecastsDesc: 'Previsioni a 13 settimane sulla base dei flussi',
      board: 'Piano dei Conti',
      boardDesc: 'Struttura contabile dettagliata',
      businessPlan: 'Business Plan',
      businessPlanDesc: 'Pianificazione strategica aziendale',
      businessIntelligence: 'Registro Imprese',
      businessIntelligenceDesc: 'Ricerca aziende e schede dal Registro Imprese',
      patrimoniale: 'Patrimoniale',
      patrimonialeDesc: 'Stato patrimoniale e asset aziendali',
      uploadFile: 'Carica File',
      integrations: 'Integrazioni',
      company: 'Azienda',
      sid: 'Comunicazioni SID',
      sidStorico: 'Storico SID',
      sidCertificato: 'Certificato SID',
      sidAdmin: 'Amministrazione SID',
      rei: 'PongoRei',
      f24: 'Pagamenti F24',
      purchaseOrders: 'Fatture Fornitori',
      invoiceVerification: 'Verifica Fatture',
      companyCreditCards: 'Carte Aziendali',
      journalEntries: 'Prima Nota',
      logout: 'Esci',
      lightTheme: 'Tema chiaro',
      darkTheme: 'Tema scuro',
      plan: 'Piano',
      daysLeft: 'giorni rimasti',
      language: 'Lingua',
      theme: 'Tema',
      upgradePlan: 'Passa a Pro',
      importData: 'Importare dei dati',
      exportData: 'Esportare i miei dati',
      settings: 'Impostazioni',
      // Section titles
      sectionAccounting: 'Contabilità',
      sectionFinancial: 'Area Finanziaria',
    },
    
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      overview: 'Panoramica finanziaria',
      thisMonth: 'Questo mese',
      lastMonth: 'Mese scorso',
      quarter: 'Trimestre',
      year: 'Anno',
      lastYear: 'Anno scorso',
      period: 'Periodo',
      print: 'Stampa',
      income: 'Entrate',
      expenses: 'Uscite',
      savings: 'Risparmio',
      fixedCosts: 'Costi Fissi',
      variableCosts: 'Costi Variabili',
      topCategories: 'Top Categorie',
      fiscalDeadlines: 'Prossime Scadenze Fiscali',
      urgent: 'urgenti',
      noData: 'Nessun dato disponibile. Inizia caricando un estratto conto!',
      showAmounts: 'Importi visibili',
      hideAmounts: 'Importi nascosti',
      vsLastMonth: 'vs mese scorso',
      insights: 'Insight',
      trendExpenses: 'Andamento spese',
      expenseDistribution: 'Distribuzione Spese',
      fixedVsVariable: 'Costi Fissi vs Variabili',
      fixed: 'Fissi',
      variable: 'Variabili',
      timeline: 'Andamento nel Tempo',
      ofExpenses: 'delle uscite',
      noDeadlines: 'Nessuna scadenza nei prossimi 60 giorni',
      viewAllDeadlines: 'Vedi tutte le',
      deadlines: 'scadenze',
      fiscalDisclaimer: 'Scadenziario fiscale Italia • Verifica sempre con il tuo commercialista',
      today: 'OGGI',
      tomorrow: 'Domani',
      days: 'gg',
    },
    
    // Chat / Assistant
    chat: {
      title: 'Assistente AI',
      subtitle: 'Analisi finanziaria intelligente con RAG',
      newConversation: 'Nuova conversazione',
      conversation: 'Conversazione',
      newChat: 'Nuova Chat',
      startConversation: 'Come posso aiutarti oggi?',
      helpText: 'Sono il tuo assistente finanziario intelligente. Analizzo le tue transazioni per darti insights concreti e azionabili.',
      
      // Categorie domande
      categoryFinance: '💰 Analisi Finanziaria',
      categoryNormativa: '⚖️ Normativa Italiana',
      categoryReports: '📊 Report & Export',
      
      examples: 'Cosa puoi chiedermi:',
      example1: 'Quanto ho speso in ristoranti questo mese?',
      example2: 'Quali sono i miei costi fissi mensili?',
      example3: 'Genera un business plan finanziario',
      example4: 'Analizza il trend delle mie spese',
      
      // Nuovi esempi normativa
      exampleNorm1: 'Quali sono gli obblighi sicurezza D.Lgs. 81/2008?',
      exampleNorm2: 'Cosa dice la normativa sulla fatturazione elettronica?',
      
      // Nuovi esempi report
      exampleReport1: 'Esporta il business plan in PDF',
      exampleReport2: 'Mostra il forecast dei prossimi 6 mesi',
      
      placeholder: 'Scrivi una domanda o carica un file...',
      transactionsAnalyzed: 'transazioni analizzate',
      openHistory: 'Apri storico chat',
      closeHistory: 'Chiudi storico',
      deleteConfirm: 'Eliminare questa conversazione?',
      noConversations: 'Nessuna conversazione',
      today: 'Oggi',
      yesterday: 'Ieri',
      daysAgo: 'giorni fa',
      fileUploaded: 'File caricato:',
      transactionsFound: 'transazioni trovate e pronte per l\'analisi.',
      askAnything: 'Ora puoi chiedermi qualsiasi cosa sui tuoi movimenti!',
      uploadSuccess: 'File caricato con successo!',
      uploadError: 'Errore durante il caricamento',
      duplicateFile: 'File già caricato:',
      
      // Suggerimenti rapidi
      quickActions: 'Azioni rapide',
      analyzeExpenses: 'Analizza spese',
      categorizeAll: 'Categorizza tutto',
      generateReport: 'Genera report',
    },
    
    // Transactions
    transactions: {
      title: 'Transazioni',
      allMovements: 'Tutti i movimenti',
      search: 'Cerca transazioni...',
      noResults: 'Nessuna transazione trovata',
      date: 'Data',
      description: 'Descrizione',
      amount: 'Importo',
      category: 'Categoria',
    },
    
    // Invoices
    invoices: {
      title: 'Fatture',
      importedFrom: 'Documenti importati da Fatture in Cloud',
      showing: 'mostrando',
      of: 'di',
      totalDocs: 'documenti totali',
      allTime: 'Tutto',
      thisYear: 'Quest\'anno',
      lastYear: 'Anno scorso',
      last6Months: 'Ultimi 6 mesi',
      last3Months: 'Ultimi 3 mesi',
      thisMonth: 'Questo mese',
      lastMonth: 'Mese scorso',
    },
    
    // Reports
    reports: {
      title: 'Report',
      analysis: 'Analisi finanziaria',
      generatePdf: 'Genera PDF',
      incomeVsExpenses: 'Entrate vs Spese',
      expensesByCategory: 'Spese per categoria',
      monthlyTrend: 'Andamento mensile',
    },
    
    // Categorize
    categorize: {
      title: 'Categorizza',
      uncategorized: 'Da categorizzare',
      expenses: 'Uscite',
      income: 'Entrate',
      allDone: 'Tutto categorizzato!',
      allDoneDesc: 'Hai categorizzato tutte le transazioni.',
      remaining: 'rimanenti',
      completed: 'completate',
      progress: 'Progressi',
      newCategory: 'Nuova categoria',
      selectCategory: 'Seleziona categoria',
      skip: 'Salta',
      undo: 'Annulla',
    },
    
    // Business Intelligence
    businessIntelligence: {
      title: 'Registro Imprese',
      subtitle: 'Ricerca aziende e schede dati dal Registro Imprese',
      searchCompany: 'Cerca azienda',
      byName: 'Per ragione sociale',
      byVat: 'Per P.IVA',
      byTaxCode: 'Per C.F.',
      search: 'Cerca',
      companyData: 'Dati azienda',
      cameralRecord: 'Scheda Registro Imprese',
      requestDocument: 'Richiedi documento',
      documentHistory: 'Storico documenti',
      noAccess: 'Funzionalità non inclusa nel tuo piano',
    },
    
    // Forecasts
    forecasts: {
      title: 'Previsioni',
      aiAnalysis: 'Analisi AI sui dati',
      subtitle: 'Previsioni intelligenti basate sui tuoi dati',
      historical: 'Storico',
      predicted: 'Previsto',
      confidence: 'Affidabilità',
      expensesTrend: 'Andamento spese previsto',
      nextMonths: 'Prossimi mesi',
      aiInsights: 'Insight AI',
      noInsights: 'Carica più dati per ottenere insight personalizzati',
      insufficientData: 'Dati insufficienti',
      loadMoreData: 'Carica più estratti conto per generare previsioni accurate.',
      expensesGrowing: 'Spese in aumento',
      expensesGrowingMsg: 'Le tue spese stanno crescendo di circa {percent}% al mese. Considera di rivedere le spese variabili.',
      goodControl: 'Ottimo controllo spese',
      goodControlMsg: 'Le tue spese stanno diminuendo di circa {percent}% al mese. Continua così!',
      highFixedCosts: 'Costi fissi elevati',
      highFixedCostsMsg: 'I costi fissi rappresentano il {percent}% delle spese. Valuta se puoi rinegoziare abbonamenti o contratti.',
      highVolatility: 'Spese molto variabili',
      highVolatilityMsg: 'Le tue spese variano molto (volatilità {percent}%). Le previsioni potrebbero essere meno accurate.',
      stableExpenses: 'Spese stabili',
      stableExpensesMsg: 'Le tue spese sono molto stabili, il che rende le previsioni più affidabili.',
      savingsRate: 'Tasso di risparmio',
      savingsRateMsg: 'Stai risparmiando in media €{amount} al mese ({percent}% delle entrate).',
      overspending: 'Attenzione: Spese superiori alle entrate',
      overspendingMsg: 'In media spendi €{amount} in più di quanto guadagni.',
      income: 'Entrate',
      expenses: 'Uscite',
      fixedCosts: 'Costi fissi',
      variableCosts: 'Costi variabili',
      statistics: 'Statistiche',
      avgMonthlyExpenses: 'Spese medie mensili',
      avgMonthlyIncome: 'Entrate medie mensili',
      volatility: 'Volatilità',
    },
    
    // Upload
    upload: {
      title: 'Carica File',
      uploadStatement: 'Carica estratto conto',
      dragDrop: 'Trascina qui i file o clicca per selezionare',
      supportedFormats: 'Formati supportati: CSV, XLSX, XLS, PDF',
      processing: 'Elaborazione...',
      success: 'File caricato con successo!',
      error: 'Errore durante il caricamento',
      completed: 'Completato',
      waiting: 'In attesa',
      maxSize: 'Max 50MB per file',
      uploadedFiles: 'File Caricati',
      noFiles: 'Nessun file caricato',
      reprocess: 'Ri-elabora tutti',
      duplicateFile: 'File già caricato',
      rows: 'righe',
      deleteConfirm: 'Eliminare questo file?',
    },
    
    // Integrations
    integrations: {
      title: 'Integrazioni',
      subtitle: 'Collega i tuoi servizi esterni per importare automaticamente i dati',
      connect: 'Connetti',
      connected: 'Connesso',
      disconnect: 'Disconnetti',
      sync: 'Sincronizza',
      syncing: 'Sincronizzazione...',
      lastSync: 'Ultimo sync',
      expired: 'Scaduto',
      error: 'Errore',
      cashbook: 'Prima nota (Cashbook)',
      invoicesIssued: 'Fatture emesse e ricevute',
      receipts: 'Ricevute e corrispettivi',
      importInvoices: 'Importa fatture, prima nota e corrispettivi',
      comingSoon: 'Prossimamente',
    },
    
    // Account
    account: {
      title: 'Azienda',
      settings: 'Gestisci i dati aziendali, fiscali e il team',
      plan: 'Piano',
      upgrade: 'Aggiorna',
      fiscalData: 'Dati Fiscali',
      fiscalDataDesc: 'Configura i dati fiscali per personalizzare le scadenze',
      saved: 'Salvato',
      companyName: 'Ragione Sociale',
      vatNumber: 'Partita IVA',
      taxCode: 'Codice Fiscale',
      team: 'Team',
      invite: 'Invita',
      owner: 'Proprietario',
      admin: 'Amministratore',
      member: 'Membro',
    },
    
    // Common
    common: {
      loading: 'Caricamento...',
      error: 'Errore',
      save: 'Salva',
      cancel: 'Annulla',
      delete: 'Elimina',
      edit: 'Modifica',
      confirm: 'Conferma',
      back: 'Indietro',
      next: 'Avanti',
      close: 'Chiudi',
      search: 'Cerca',
      filter: 'Filtra',
      all: 'Tutti',
      none: 'Nessuno',
      yes: 'Sì',
      no: 'No',
      language: 'Lingua',
      italian: 'Italiano',
      english: 'English',
    },
  },
  
  en: {
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      treasury: 'Treasury',
      treasuryDesc: 'Treasury management, forecasts, debts, investments',
      assistant: 'AI Assistant',
      aiGovernance: 'AI Governance',
      transactions: 'Transactions',
      transactionsDesc: 'Bank movements and cash position',
      invoices: 'Invoices',
      invoicesDesc: 'Manage active and passive invoices',
      reconciliation: 'Reconciliation',
      reconciliationDesc: 'Reconcile transactions with invoices',
      categorize: 'Categorize',
      categorizeDesc: 'Automatically classify transactions',
      reports: 'Reports',
      reportsDesc: 'Financial analysis and detailed reports',
      forecasts: 'Forecasts',
      forecastsDesc: '13-week forecasts based on cash flows',
      board: 'Chart of Accounts',
      boardDesc: 'Detailed accounting structure',
      businessPlan: 'Business Plan',
      businessPlanDesc: 'Strategic business planning',
      businessIntelligence: 'Business Register',
      businessIntelligenceDesc: 'Company search and registry extracts',
      patrimoniale: 'Balance Sheet',
      patrimonialeDesc: 'Balance sheet and company assets',
      uploadFile: 'Upload File',
      integrations: 'Integrations',
      company: 'Company',
      sid: 'SID Communications',
      sidStorico: 'SID History',
      sidCertificato: 'SID Certificate',
      sidAdmin: 'SID Administration',
      rei: 'PongoRei',
      f24: 'F24 Payments',
      purchaseOrders: 'Supplier Invoices',
      invoiceVerification: 'Invoice Verification',
      companyCreditCards: 'Company Cards',
      journalEntries: 'Journal Entries',
      logout: 'Logout',
      lightTheme: 'Light theme',
      darkTheme: 'Dark theme',
      plan: 'Plan',
      daysLeft: 'days left',
      language: 'Language',
      theme: 'Theme',
      upgradePlan: 'Upgrade to Pro',
      importData: 'Import data',
      exportData: 'Export my data',
      settings: 'Settings',
      // Section titles
      sectionAccounting: 'Accounting',
      sectionFinancial: 'Financial Area',
    },
    
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      overview: 'Financial overview',
      thisMonth: 'This month',
      lastMonth: 'Last month',
      quarter: 'Quarter',
      year: 'Year',
      lastYear: 'Last year',
      period: 'Period',
      print: 'Print',
      income: 'Income',
      expenses: 'Expenses',
      savings: 'Savings',
      fixedCosts: 'Fixed Costs',
      variableCosts: 'Variable Costs',
      topCategories: 'Top Categories',
      fiscalDeadlines: 'Upcoming Tax Deadlines',
      urgent: 'urgent',
      noData: 'No data available. Start by uploading a bank statement!',
      showAmounts: 'Amounts visible',
      hideAmounts: 'Amounts hidden',
      vsLastMonth: 'vs last month',
      insights: 'Insights',
      trendExpenses: 'Expense trend',
      expenseDistribution: 'Expense Distribution',
      fixedVsVariable: 'Fixed vs Variable Costs',
      fixed: 'Fixed',
      variable: 'Variable',
      timeline: 'Timeline',
      ofExpenses: 'of expenses',
      noDeadlines: 'No deadlines in the next 60 days',
      viewAllDeadlines: 'View all',
      deadlines: 'deadlines',
      fiscalDisclaimer: 'Italian tax calendar • Always check with your accountant',
      today: 'TODAY',
      tomorrow: 'Tomorrow',
      days: 'd',
    },
    
    // Chat / Assistant
    chat: {
      title: 'AI Assistant',
      subtitle: 'Intelligent financial analysis with RAG',
      newConversation: 'New conversation',
      conversation: 'Conversation',
      newChat: 'New Chat',
      startConversation: 'How can I help you today?',
      helpText: 'I\'m your intelligent financial assistant. I analyze your transactions to give you concrete, actionable insights.',
      
      // Question categories
      categoryFinance: '💰 Financial Analysis',
      categoryNormativa: '⚖️ Italian Regulations',
      categoryReports: '📊 Reports & Export',
      
      examples: 'What you can ask me:',
      example1: 'How much did I spend on restaurants this month?',
      example2: 'What are my monthly fixed costs?',
      example3: 'Generate a financial business plan',
      example4: 'Analyze my expense trends',
      
      // New normativa examples
      exampleNorm1: 'What are the safety obligations under D.Lgs. 81/2008?',
      exampleNorm2: 'What does the regulation say about electronic invoicing?',
      
      // New report examples
      exampleReport1: 'Export business plan as PDF',
      exampleReport2: 'Show forecast for next 6 months',
      
      placeholder: 'Ask a question or upload a file...',
      transactionsAnalyzed: 'transactions analyzed',
      openHistory: 'Open chat history',
      closeHistory: 'Close history',
      deleteConfirm: 'Delete this conversation?',
      noConversations: 'No conversations',
      today: 'Today',
      yesterday: 'Yesterday',
      daysAgo: 'days ago',
      fileUploaded: 'File uploaded:',
      transactionsFound: 'transactions found and ready for analysis.',
      askAnything: 'Now you can ask me anything about your transactions!',
      uploadSuccess: 'File uploaded successfully!',
      uploadError: 'Error uploading file',
      duplicateFile: 'File already uploaded:',
      
      // Quick actions
      quickActions: 'Quick actions',
      analyzeExpenses: 'Analyze expenses',
      categorizeAll: 'Categorize all',
      generateReport: 'Generate report',
    },
    
    // Transactions
    transactions: {
      title: 'Transactions',
      allMovements: 'All movements',
      search: 'Search transactions...',
      noResults: 'No transactions found',
      date: 'Date',
      description: 'Description',
      amount: 'Amount',
      category: 'Category',
    },
    
    // Invoices
    invoices: {
      title: 'Invoices',
      importedFrom: 'Documents imported from Fatture in Cloud',
      showing: 'showing',
      of: 'of',
      totalDocs: 'total documents',
      allTime: 'All time',
      thisYear: 'This year',
      lastYear: 'Last year',
      last6Months: 'Last 6 months',
      last3Months: 'Last 3 months',
      thisMonth: 'This month',
      lastMonth: 'Last month',
    },
    
    // Reports
    reports: {
      title: 'Reports',
      analysis: 'Financial analysis',
      generatePdf: 'Generate PDF',
      incomeVsExpenses: 'Income vs Expenses',
      expensesByCategory: 'Expenses by category',
      monthlyTrend: 'Monthly trend',
    },
    
    // Categorize
    categorize: {
      title: 'Categorize',
      uncategorized: 'To categorize',
      expenses: 'Expenses',
      income: 'Income',
      allDone: 'All categorized!',
      allDoneDesc: 'You have categorized all transactions.',
      remaining: 'remaining',
      completed: 'completed',
      progress: 'Progress',
      newCategory: 'New category',
      selectCategory: 'Select category',
      skip: 'Skip',
      undo: 'Undo',
    },
    
    // Business Intelligence
    businessIntelligence: {
      title: 'Business Register',
      subtitle: 'Company search and registry extracts',
      searchCompany: 'Search company',
      byName: 'By name',
      byVat: 'By VAT',
      byTaxCode: 'By Tax Code',
      search: 'Search',
      companyData: 'Company data',
      cameralRecord: 'Registry extract',
      requestDocument: 'Request document',
      documentHistory: 'Document history',
      noAccess: 'Feature not included in your plan',
    },
    
    // Forecasts
    forecasts: {
      title: 'Forecasts',
      aiAnalysis: 'AI analysis on data',
      subtitle: 'Smart predictions based on your data',
      historical: 'Historical',
      predicted: 'Predicted',
      confidence: 'Confidence',
      expensesTrend: 'Expected expense trend',
      nextMonths: 'Next months',
      aiInsights: 'AI Insights',
      noInsights: 'Upload more data to get personalized insights',
      insufficientData: 'Insufficient data',
      loadMoreData: 'Upload more bank statements to generate accurate forecasts.',
      expensesGrowing: 'Expenses increasing',
      expensesGrowingMsg: 'Your expenses are growing by about {percent}% per month. Consider reviewing variable expenses.',
      goodControl: 'Great expense control',
      goodControlMsg: 'Your expenses are decreasing by about {percent}% per month. Keep it up!',
      highFixedCosts: 'High fixed costs',
      highFixedCostsMsg: 'Fixed costs represent {percent}% of expenses. Consider renegotiating subscriptions or contracts.',
      highVolatility: 'Highly variable expenses',
      highVolatilityMsg: 'Your expenses vary a lot (volatility {percent}%). Forecasts may be less accurate.',
      stableExpenses: 'Stable expenses',
      stableExpensesMsg: 'Your expenses are very stable, making forecasts more reliable.',
      savingsRate: 'Savings rate',
      savingsRateMsg: 'You are saving an average of €{amount} per month ({percent}% of income).',
      overspending: 'Warning: Expenses exceed income',
      overspendingMsg: 'On average you spend €{amount} more than you earn.',
      income: 'Income',
      expenses: 'Expenses',
      fixedCosts: 'Fixed costs',
      variableCosts: 'Variable costs',
      statistics: 'Statistics',
      avgMonthlyExpenses: 'Avg monthly expenses',
      avgMonthlyIncome: 'Avg monthly income',
      volatility: 'Volatility',
    },
    
    // Upload
    upload: {
      title: 'Upload File',
      uploadStatement: 'Upload bank statement',
      dragDrop: 'Drag files here or click to select',
      supportedFormats: 'Supported formats: CSV, XLSX, XLS, PDF',
      processing: 'Processing...',
      success: 'File uploaded successfully!',
      error: 'Error uploading file',
      completed: 'Completed',
      waiting: 'Waiting',
      maxSize: 'Max 50MB per file',
      uploadedFiles: 'Uploaded Files',
      noFiles: 'No files uploaded',
      reprocess: 'Reprocess all',
      duplicateFile: 'File already uploaded',
      rows: 'rows',
      deleteConfirm: 'Delete this file?',
    },
    
    // Integrations
    integrations: {
      title: 'Integrations',
      subtitle: 'Connect your external services to automatically import data',
      connect: 'Connect',
      connected: 'Connected',
      disconnect: 'Disconnect',
      sync: 'Sync',
      syncing: 'Syncing...',
      lastSync: 'Last sync',
      expired: 'Expired',
      error: 'Error',
      cashbook: 'Cashbook',
      invoicesIssued: 'Issued and received invoices',
      receipts: 'Receipts',
      importInvoices: 'Import invoices, cashbook and receipts',
      comingSoon: 'Coming soon',
    },
    
    // Account
    account: {
      title: 'Company',
      settings: 'Manage company data, fiscal info and team',
      plan: 'Plan',
      upgrade: 'Upgrade',
      fiscalData: 'Fiscal Data',
      fiscalDataDesc: 'Configure fiscal data to customize deadlines',
      saved: 'Saved',
      companyName: 'Company Name',
      vatNumber: 'VAT Number',
      taxCode: 'Tax Code',
      team: 'Team',
      invite: 'Invite',
      owner: 'Owner',
      admin: 'Admin',
      member: 'Member',
    },
    
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      close: 'Close',
      search: 'Search',
      filter: 'Filter',
      all: 'All',
      none: 'None',
      yes: 'Yes',
      no: 'No',
      language: 'Language',
      italian: 'Italiano',
      english: 'English',
    },
  },
} as const

export type TranslationKeys = typeof translations['it'] | typeof translations['en']
